import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import Footer from '../components/Footer';
import { useAuth } from '../contexts/AuthContext';
import { navigateToHome } from '../utils/navigation';

const PrivacyPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  React.useEffect(() => {
    document.title = 'Privacy Policy — I Need Numbers';
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <nav className="bg-white/80 backdrop-blur-md border-b border-neutral-medium/20">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <Button
                variant="ghost"
                onClick={() => navigateToHome(navigate, user)}
                className="text-deep-forest hover:text-primary"
                data-testid="privacy-back-btn"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Home
              </Button>
              <div className="flex items-center space-x-2">
                <img 
                  src="https://customer-assets.emergentagent.com/job_agent-portal-27/artifacts/azdcmpew_Logo_with_brown_background-removebg-preview.png" 
                  alt="I Need Numbers" 
                  className="h-8 w-auto"
                />
                <span className="text-lg font-bold text-primary font-poppins">I NEED NUMBERS</span>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div className="flex-grow" data-testid="privacy-policy-embed">
        <iframe
          src="https://app.termly.io/policy-viewer/policy.html?policyUUID=caba33e8-4858-4f1f-a26d-04967ad651ff"
          title="Privacy Policy"
          style={{ width: '100%', height: '100%', minHeight: 'calc(100vh - 140px)', border: 'none' }}
        />
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
